import { useState } from 'react';
import { objectMapSelector } from 'slices/object.slice';
import { useAppSelector } from 'slices/store';
import { validateExtIdAvailability } from 'utils/objectManager';
import type { TTEObject } from '@timeedit/types';

export const useExtIdValidation = (object: TTEObject) => {
  const [extIdValidationStatus, setExtIdValidationStatus] = useState<
    'validating' | 'success' | 'error' | 'warning' | undefined
  >(undefined);
  const objectMap = useAppSelector(objectMapSelector);
  const storeObject = objectMap[object.id];

  const validateExtId = async (extId: string) => {
    if (!extId) {
      setExtIdValidationStatus(undefined);
      return Promise.resolve();
    }
    if (extId === storeObject.extId) {
      setExtIdValidationStatus(undefined);
      return Promise.resolve();
    }

    setExtIdValidationStatus('validating');
    const res = await validateExtIdAvailability(extId);
    if (res) {
      setExtIdValidationStatus('success');
      return Promise.resolve('Ext. Id is available!');
    }
    setExtIdValidationStatus('error');
    return Promise.reject(new Error('Ext. Id already exists!'));
  };

  return { extIdValidationStatus, validateExtId };
};
